import React from "react";
import { Col, Container, Row} from "reactstrap";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import RealEnglishSliderImages from "./RealEnglishSliderImages/RealEnglishSliderImages";

const OurSchool = () => {

  return (
    <section
      className="section"
      id="OurSchool"
    >
      <Container>
        <Row className="justify-content-center ">
          <Col lg={10}>
            <div className="p-5 text-center">
              <div className="d-flex align-items-center justify-content-center pb-3">
                <h2 className="display-6 fw-bold text-primary mb-0 ps-2">Our School</h2>
              </div>

              <p className="lead  lh-base mt-3">
                Our vision reimagines traditional classrooms, creating dynamic,
                student-centered environments. The results speak volumes:
                increased engagement, collaboration, and joy in learning.
              </p>
              <p className="lead  lh-base">
                With flexible seating, interactive technology, and
                Montessori-inspired settings, students thrive. Our approach
                enhances learning outcomes and cultivates a culture of curiosity
                and creativity.
              </p>
              <p className="lead  lh-base">
                Through innovative design and pedagogy, we’re shaping the future
                of education—one vibrant classroom at a time!
              </p>
              <div className="d-flex justify-content-center mt-4">
                <div className="p-3 text-center">
                  <i className="mdi mdi-seat-recline-extra fs-36 text-success"></i>
                  <p className="mt-2 ">Flexible Seating</p>
                </div>
                <div className="p-3 text-center">
                  <i className="mdi mdi-monitor-dashboard fs-36 text-primary"></i>
                  <p className="mt-2 ">Interactive Technology</p>
                </div>
                <div className="p-3 text-center">
                  <i className="mdi mdi-trophy fs-36 text-warning mb-3"></i>
                  <p className="mt-2 ">ELT Excellence Award 2024</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        
      </Container>
        <RealEnglishSliderImages/>
    </section>
  );
};

export default OurSchool;
